import { useContext, useState } from "react";
import { AppContext } from "../State/Context";
import { ActionType } from "../State/State";
import { getWorldCoordsToCenterHex } from "../State/stateUtils";
import { Hexagen } from "../types";
import { SmallCard } from "./SmallCard";

type CardTileListProps = {
  hexagens: Hexagen[];
  onSelect?: (hexagen: Hexagen) => void;
};

export const CardTileList = ({ hexagens, onSelect }: CardTileListProps) => {
  const { state, dispatch } = useContext(AppContext);
  const [touchStart, setTouchStart] = useState<{ x: number; y: number } | null>(
    null
  );
  const [isScrolling, setIsScrolling] = useState(false);

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart({
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    });
    setIsScrolling(false);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!touchStart) return;

    const deltaX = Math.abs(e.touches[0].clientX - touchStart.x);
    const deltaY = Math.abs(e.touches[0].clientY - touchStart.y);

    if (deltaX > 10 || deltaY > 10) {
      setIsScrolling(true);
    }
  };

  const handleTouchEnd = () => {
    setTouchStart(null);
    setTimeout(() => setIsScrolling(false), 100);
  };

  const clickOnCard = (hexagen: Hexagen) => {
    if (onSelect) {
      onSelect(hexagen);
      return;
    }

    if (isScrolling) return;

    dispatch({ type: ActionType.SELECT_HEX, x: hexagen.x, y: hexagen.y });
    dispatch({ type: ActionType.OPEN_HEX_INFO_POPUP });
    const coords = getWorldCoordsToCenterHex(hexagen.x, hexagen.y, state.worldScale);
    dispatch({ type: ActionType.CHANGE_WORLD_COORDINATES, x: coords.worldX, y: coords.worldY, logggable: true });
  };

  return (
    <div className="text-center">
      {hexagens.map((hexagen) => (
        <div
          key={hexagen.uid}
          className="inline-block align-top w-[130px] h-[160px] m-1"
          onClick={() => clickOnCard(hexagen)}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <SmallCard hexagenInfo={hexagen} />
        </div>
      ))}
    </div>
  );
};
